// Browser polyfills for the Node globals algosdk / algokit-utils / use-wallet
// expect (Buffer, process, global). Replaces vite-plugin-node-polyfills, which
// under Vite 6 / Rollup 4 broke commonjs interop for every CJS dependency.
// Imported first in index.jsx so these globals exist before any dep evaluates.
import { Buffer } from 'buffer';
import process from 'process';

globalThis.Buffer = globalThis.Buffer || Buffer;
globalThis.process = globalThis.process || process;
globalThis.global = globalThis.global || globalThis;
